import Input, { InputProps, InputMail } from "./Input";

export { Input, InputMail };
export type { InputProps };
export const InputField = Input;
export default InputField;

